import {CanActivate, CanActivateFn, Router} from '@angular/router';
import {inject} from "@angular/core";
import {catchError, defaultIfEmpty, map, of, startWith, switchMap, take} from "rxjs";
import {UserService} from "../services/user.service";


export const authGuard: CanActivateFn = (route, state) => {

  const userService = inject(UserService);
  const router = inject(Router);

  if(userService.userObject.value !== null){ //we have user in memory
    // console.log('authguard says OK, we have user object')
    return true
  }

  //user refreshed page - we have token in localStorage and the userObject will be restored in authService
  let token: string | null = null;
  try {
    token = localStorage.getItem('sessionToken');
  } catch (error) {
    console.warn('Error accessing localStorage in authGuard:', error);
  }

  if(token){
    return userService.getUserInfo().pipe(
      take(1),
      defaultIfEmpty(false), //to prevent EMPTY error coming from authInterceptor on 401 could not authenticate request error
      switchMap(user => {
        if (user){
          // console.log('authguard says OK, we have user after getting it from restored token')
          return of(true);
        }
        // console.log('authguard says no user, token expired, no navigation')
        //error handled in authInterceptor(401) for expired/invalid token
        router.navigate(['']);
        return of(false)
      }),
      catchError(()=>{
        // console.log('authguard says no user, error catched while getting user details')
        //errors from getUserInfo (network, error in message, sent without token) - handled on home
        router.navigate(['']);
        return of(false)
      })
    )
  }

  // console.log('authguard says no user, no token, so no navigation')
  router.navigate([''])
  return false;


}





/**
 * saved/published version
 * */
// declare var bootstrap: any;
// //todo refactor this guard!!! --> done, remove this from here

// export const authGuard: CanActivateFn = (route, state) => {
//   const userService = inject(UserService);
//   // const authService = inject(AuthService);
//   const router = inject(Router);
//
//   // console.log('auth guard worked') //todo
//
//   if (userService.userObject.value !== null) {
//   // if (authService.token.value !== null) { //check token instead?
//     //todo check if user info is still valid before letting navigation go BUG HERE
//     return true;
//     // console.log("todo check if user info is still valid before letting navigation go")
//     // return userService.getUserInfo().pipe(
//     //   catchError((error) => {
//     //     router.navigate(['']);
//     //     showSignInModal();
//     //     console.log(error) todo warn user about the expired token
//     //     return of(false);
//     //   }),
//     //   map(() => true)
//     //
//     // );
//   }
//
//   // if we have token in authservice, this wont happen: //check token instead?
//   let token: string | null = null;
//   try {
//     token = localStorage.getItem('sessionToken');
//   } catch (error) {
//     console.warn('Error accessing localStorage:', error);
//     //no need to check the token in authService because it will be there(as the userobject, so we can let navigation continue)
//     // const authService = inject(AuthService);
//     // token = authService.token.value;
//   }
//
//   if (token) {
//     //if we have token in localstorage that we can access and we dont have token in app
//     // console.log('getuserInfo piped from interceptor') //todo
//     return userService.getUserInfo().pipe(
//       catchError((error) => {
//         router.navigate(['']);
//         showSignInModal(); //todo
//         // console.log(error)
//         return of(false);
//       }),
//       map(() => true)
//     );
//   }
//   //no localstorage, no data in app services and BS, like refreshing window
//   router.navigate(['']);
//   // showSignInModal(); //todo or give a warning to user that they may should log in again (like the one needed instead of not found for games)
//   return false;
// };
//
// function showSignInModal() {
//   // console.log('showmodal called') //todo
//
//   //deactivate Bootstrap modals preventing text input fields focus
//   // bootstrap.Modal.prototype._initializeFocusTrap = function () { return { activate: function () { }, deactivate: function () { } } };
//   // const signInModal = new bootstrap.Modal(document.getElementById('signInModal'), {})
//   // signInModal.show()
//
//   try {
//     if (typeof bootstrap === 'undefined' || !bootstrap.Modal) {
//       throw new Error('Bootstrap library is not loaded.');
//     }
//     // Deactivate Bootstrap modals preventing text input fields focus
//     bootstrap.Modal.prototype._initializeFocusTrap = function () {
//       return {
//         activate: function () { },
//         deactivate: function () { }
//       };
//     };
//     const modalElement = document.getElementById('signInModal');
//     console.log(modalElement) //todo this is null when refreshing the page, find out how to open it before throwing error
//     if (!modalElement) {
//       throw new Error('Modal element with ID "signInModal" not found.');
//     }
//     const signInModal = new bootstrap.Modal(modalElement, {});
//     signInModal.show();
//   } catch (error) {
//     console.error('Error in toggleSignInModal:', error);
//     // const router = inject(Router);
//     // router.navigate(['/legacy']);
//   }
// }



/**
 * Original version from 2024 dec
 * */
/*
declare var bootstrap: any;

export const authGuard: CanActivateFn = (route, state) => {
  const userService = inject(UserService);
  const router = inject(Router);

  if (userService.userObject.value !== null) {
    return true;
  }

  const token = localStorage.getItem('sessionToken');
  if (token) {
    return userService.getUserInfo().pipe(
      catchError((error) => {
        router.navigate(['']);
        showSignInModal(); //todo
        return of(false);
      }),
      map(() => true)
    );
  }
  router.navigate(['']);
  // showSignInModal(); //todo or give a warning to user that they may should log in again (like the one needed instead of not found for games)
  return false;
};

function showSignInModal() {
  // console.log('showmodal called') //todo

  //deactivate Bootstrap modals preventing text input fields focus
  bootstrap.Modal.prototype._initializeFocusTrap = function () { return { activate: function () { }, deactivate: function () { } } };
  const signInModal = new bootstrap.Modal(document.getElementById('signInModal'), {})
  signInModal.show()

}
*/
